import React from 'react';
import './AboutMe.css';
import about_me from '../../images/about_me.gif';

const AboutMe = () => {
    return (
        <div className='about__section'>
            <div className='about_me_text' data-aos="fade-up" data-aos-duration="2000">
                <p>
                    Hi, I'm <span>Naime Molla</span> - a <span>Front-end</span> web application developer located from Dhaka, Bangladesh. I always like to introduce myself as a punctual worker, full-time learner and professional Google searcher. Learning new technologies is my happiness. Passionate about building scalable web apps. I am looking for an opportunity to exploit my skills. At the end of the day, I'm a simple human being.
                </p>
            </div>
            <div className='about_me_image' data-aos="fade-down" data-aos-duration="2000">
                <img src={about_me} alt="about me animated img" />
            </div>
        </div>
    );
};

export default AboutMe;